export default "__VITE_ASSET__DvzL14HS__"